export default "__VITE_ASSET__qq1Gkc71__"